import { RemoteDeleteRoute } from '@/javascript/data/usecases/maps/remote-delete-route'
import { DeleteRoute } from '@/javascript/domain/usecases/maps/delete-route'
import { makeApiUrl, makeAxiosHttpClient } from '@/javascript/main/factories/http'

export const makeRemoteDeleteRoute = (): DeleteRoute =>
  new RemoteDeleteRoute(makeApiUrl('/maps/routes'), makeAxiosHttpClient())
